<template>
  <div v-if="isVisible" class="fixed inset-0 bg-gray-600 bg-opacity-70 z-50 flex justify-center items-center p-4">
    <div class="bg-white dark:bg-gray-800 p-6 rounded-lg w-full max-w-md">
      <h2 class="text-lg font-semibold dark:text-gray-100 mb-4">Transfer Ticket #{{ sourceTicketId }}</h2>
      <label for="tech" class="block text-sm font-medium text-gray-700 dark:text-gray-100 mb-2">Select Tech</label>
      <select id="tech" v-model="selectedTech" class="w-full p-2 rounded-md border-gray-300 shadow-sm text-xs dark:bg-gray-500 dark:border-gray-600 dark:text-gray-100 mb-4">
        <option value="0">Send to Delegator</option>
        <template v-for="(techList, deptName) in groupedTechs" :key="deptName">
          <optgroup v-if="deptName" :label="deptName">
            <option v-for="tech in techList" :key="tech.id" :value="tech.id">
              {{ tech.name }}
            </option>
          </optgroup>
          <template v-else>
            <option v-for="tech in techList" :key="tech.id" :value="tech.id">
              {{ tech.name }}
            </option>
          </template>
        </template>
      </select>

      <label for="note" class="block text-sm font-medium text-gray-700 dark:text-gray-100 mb-2">Transfer Note</label>
      <textarea id="note" v-model="note" rows="3" class="w-full p-2 rounded-md border-gray-300 shadow-sm dark:bg-gray-500 dark:border-gray-600 dark:text-gray-100 mb-4"></textarea>

      <div class="flex items-center mb-4">
        <input type="checkbox" id="notify" v-model="notify" class="mr-2 text-blue-600 dark:text-gray-900 rounded" />
        <label for="notify" class="block text-sm font-medium text-gray-700 dark:text-gray-100">Notify requester of transfer?</label>
      </div>
      <div class="flex justify-end space-x-2 mt-4">
        <button @click="closeModal()" class="bg-gray-400 hover:bg-gray-600 text-white font-bold py-2 px-4 rounded dark:bg-red-500 dark:hover:bg-red-700">Cancel</button>
        <button @click="save()" class="bg-yellow-500 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded dark:bg-yellow-500 dark:hover:bg-yellow-700">Transfer</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isVisible: {
      type: Boolean,
      required: true
    },
    sourceTicketId: {
      type: Number,
      required: true
    },
    techs: {
      type: Array,
      required: true
    },
    currentTech: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      selectedTech: 0,
      notify: false,
      note: '',
      // techs: [
      //   { id: 1, name: 'Gali, Mary' },
      //   { id: 2, name: 'Tech 2' },
      //   // Add more techs here
      // ]
    };
  },
  computed: {
    groupedTechs() {
      const groups = {};
      const ungrouped = [];

      this.techs.forEach(tech => {
        if (!tech.deptId) {
          // No deptId at all → push to ungrouped
          ungrouped.push({
            id: tech.id,
            name: tech.name,
          });
          return;
        }

        let groupKey = '';

        if (tech.deptId === "External Tech") {
          groupKey = "External Tech";
        } else if (tech.details) {
          groupKey = tech.details;
        } else {
          groupKey = "Other Department";
        }

        if (!groups[groupKey]) {
          groups[groupKey] = [];
        }

        // Append company name for external techs
        let displayName = tech.name;
        if (tech.deptId === "External Tech" && tech.details) {
          displayName += ` (${tech.details})`;
        }

        groups[groupKey].push({
          id: tech.id,
          name: displayName,
        });
      });

      // If ungrouped exist, add as a group at the top
      if (ungrouped.length > 0) {
        groups[""] = ungrouped; // Empty string so it doesn't show a group label
      }

      // Get keys and sort
      let keys = Object.keys(groups).filter(k => k !== "External Tech").sort((a, b) => {
        if (a === "") return -1; // Keep ungrouped first
        if (b === "") return 1;
        return a.localeCompare(b);
      });

      // Add External Tech last
      if (groups["External Tech"]) {
        keys.push("External Tech");
      }

      // Rebuild ordered groups object
      const orderedGroups = {};
      keys.forEach(key => {
        orderedGroups[key] = groups[key];
      });

      return orderedGroups;
    }
  },
  // mounted() {
  //   console.log(this.selectedTech)
  //   console.log(this.techs)
  // },
  methods: {
    closeModal() {
      this.selectedTech = 0;
      this.notify = false;
      this.note = '';
      this.$emit('close');
    },
    save() {
      if (this.note) {
        this.$emit('complete', {
          ticketId: this.sourceTicketId,
          curTechId: this.currentTech,
          newTechId: this.selectedTech,
          sendEmail: this.notify ? 1 : 0,
          transferNotes: this.note
        });
        this.closeModal();
      } else {
        alert('Please fill in all fields.');
      }
    }
  }
};
</script>
